<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- 第一行 标题 -->
        <div class="d-flex jc-center firstLine">
          <!-- 中间标题 -->
          <div class="titleBox">
            <img src="../../assets/images/title.png" alt="标题" />
          </div>
          <!-- 右侧时间 -->
          <div class="rightTime">
            {{ currentDate }}
          </div>
        </div>

        <!-- 第二行 中间主体内容 -->
        <div class="body-box">
          <!-- 数据列表 -->
          <div class="content-box">
            <!-- 表格页眉 -->
            <div class="thead">
              <div class="tr">
                <div class="th team">队伍</div>
                <div class="th checkPoint">CHECK POINT1</div>
                <div class="th checkPoint">CHECK POINT2</div>
                <div class="th checkPoint">CHECK POINT3</div>
                <div class="th checkPoint">CHECK POINT4</div>
                <div class="th checkPoint">CHECK POINT5</div>
                <div class="th checkPoint">CHECK POINT6</div>
                <div class="th judgesScore">Judges Appraisal*</div>
                <div class="th totalScore">Total Score</div>
                <div class="th vote">Vote</div>
                <div class="th teamIntroduc" style="margin-right:15px">
                  Team Introduce
                </div>
              </div>
            </div>
            <!-- 表格主体 -->
            <div class="tbody" v-if="teamListResult.length">
              <div class="tr" v-for="(item, index) in teamListResult" :key="item.teamName" :style="{
                  marginBottom: teamListResult.length - 1 === index ? 0 : '',
                }">
                <div class="td team">
                  <span class="teamNumber">G{{ item.teamNumber }}</span>
                  <div class="teamName">{{ formatTeamName(item) }}</div>
                </div>
                <div class="td checkPoint" v-for="(item2) in item.matchDataCheckPoints" :key="item.teamName + item2.stage">
                  {{
                    item2.checkPointState
                      ? item2.checkPointState === 1
                        ? "Ready" + `(${item2.score || 0})`
                        : "Done" + `(${item2.score || 0})`
                      : "- -"
                  }}
                </div>
                <!-- {{ item.judgesScore || 0 }} -->
                <div class="td judgesScore" @click="seeScoreDetails(item)">{{item.judgesScore}}</div>
                <div class="td totalScore">{{ item.totalScore || 0 }}</div>
                <div class="td vote">
                  <div class="ticket">{{ item.vote || 0 }}票</div>
                </div>
                <div class="td teamIntroduc">
                  <img src="../../assets/images/more.png" alt="more" @click="seeDetails(item)" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 第三行 底部 -->
        <div class="d-flex footer-box">
          <div class="footer-text">
            <div class="footer-row">
              <p><span class="footer-label">指导单位：</span>共青团江苏省委员会、共青团苏州市委员会</p>
              <p><span class="footer-label">主办单位：</span>苏州工业园区团工委、苏州独墅湖科教创新区管委会</p>
            </div>
            <div class="footer-row">
              <p><span class="footer-label">承办单位：</span>苏州独墅湖创业发展中心、苏州纳米技术大学科技园管理有限公司</p>
              <p><span class="footer-label">协办单位：</span>盛派人工智能科技(苏州)有限公司</p>
            </div>
          </div>
        </div>

        <!-- 倒计时 -->
        <div class="loginBtn">Last: {{ countDown }}</div>
        <!-- 倒计时 -->

        <!-- 队员详情弹框 -->
        <div class="mask" v-if="isDetailShow">
          <div class="teamDetails">
            <div class="titleBox" v-if="teamDetail">
              <span class="teamNumberBadge">G{{ teamDetail.teamNumber }}</span>
              <div class="title">{{ formatTeamName(teamDetail) }}</div>
            </div>
            <div class="contentBox" v-if="teamDetail">
              <div class="teamInfoPanel">
                <div class="infoRow">
                  <span class="infoLabel">组号</span>
                  <span class="infoValue">G{{ teamDetail.teamNumber }}</span>
                </div>
                <div class="infoRow" v-if="teamDetail.teamDescription">
                  <span class="infoLabel">口号</span>
                  <span class="infoValue">{{ teamDetail.teamDescription }}</span>
                </div>
                <div class="infoRow" v-if="teamDetail.teamCaptain">
                  <span class="infoLabel">队长</span>
                  <span class="infoValue">{{ teamDetail.teamCaptain }}</span>
                </div>
                <div class="infoEmpty" v-if="!hasTeamIntro(teamDetail)">
                  完成 CP2 后将展示队伍口号与队长信息
                </div>
              </div>
            </div>
            <!-- 关闭按钮 -->
            <img src="../../assets/images/close.png" alt="" class="close" @click="isDetailShow = false" />
          </div>
        </div>
        <!-- 队员详情弹框 -->

        <!-- 评分详情弹框 -->
        <div class="mask" v-if="isScoreDetailShow">
          <div class="scoreDetail">
            <div class="scoreDetail-main">
              <!-- 评分类别行 -->
              <div class="categoryLine">
                <div class="cidr">评分类别</div>
                <div class="scorePoints">得分点及分数</div>
                <div class="judgesGiveScore">
                  <div class="judgesGiveScore-title">评委打分</div>
                  <div class="judgesGiveScore-line">
                    <div class="item-judgesGiveScore">
                      <img src="../../assets/images/occupant.png" alt="评委1" />
                    </div>
                    <div class="item-judgesGiveScore">
                      <img src="../../assets/images/occupant.png" alt="评委2" />
                    </div>
                    <div class="item-judgesGiveScore">
                      <img src="../../assets/images/occupant.png" alt="评委3" />
                    </div>
                  </div>
                </div>
                <div class="shootingGuard">得分</div>
                <div class="classificationScore">分类得分</div>
                <div class="totalScore">总分</div>
              </div>
              <!-- 技术的先进性和创新性行 -->
              <div class="technology">
                <!-- 类目 -->
                <div class="technology-cidr">
                  技术的先进性和创新性(0-40分)
                </div>
                <!-- 得分点 -->
                <div class="technology-scorePoints">
                  <div class="singleRow" >
                    1、能够使用 NeuCharBox 成功运行项目 (4分)
                  </div>
                  <div class="singleRow">
                    2、能够使用 NeuCharBox 完成多个设备的协同工作 (4分)
                  </div>
                  <div class="singleRow">
                    3、能够实现智能化或自动化的成果展示，而不是硬编码 (4分)
                  </div>
                  <div class="singleRow">
                    4、产品能够及时对外部环境做出反应，没有明显停顿 (4分)
                  </div>
                  <div class="singleRow">
                    5、产品能够稳定运行，演示期间没有故障发生 (4分)
                  </div>
                  <div class="doubleRow">
                    6、在满足比赛规定功能的基础上，能够使用 1 个 ESP32 边缘设备协同工作 4分、2 个 8分、3 个或以上 12分 (满分12分)
                  </div>
                  <div class="doubleRow">
                    7、在满足比赛规定功能的基础上，应用场景具有一般创新性 4分、出色创新性 8分 (满分8分)
                  </div>
                </div>
                <!-- 评委打分 -->
                <div class="technology-judgesGiveScore">
                  <!-- A 1 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'A','1').isHighest),'greenFont':(formatJudgesScore(1,'A','1').isLowest)}">
                      {{ (formatJudgesScore(1,'A','1').finalScore) || '-' }}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'A','1').isHighest),'greenFont':(formatJudgesScore(2,'A','1').isLowest)}">
                      {{(formatJudgesScore(2,'A','1').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'A','1').isHighest),'greenFont':(formatJudgesScore(3,'A','1').isLowest)}">
                      {{(formatJudgesScore(3,'A','1').finalScore) || '-'}}
                    </div>
</div>
                  <!-- A 2 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'A','2').isHighest),'greenFont':(formatJudgesScore(1,'A','2').isLowest)}">
                      {{(formatJudgesScore(1,'A','2').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'A','2').isHighest),'greenFont':(formatJudgesScore(2,'A','2').isLowest)}">
                      {{(formatJudgesScore(2,'A','2').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'A','2').isHighest),'greenFont':(formatJudgesScore(3,'A','2').isLowest)}">
                      {{(formatJudgesScore(3,'A','2').finalScore) || '-'}}
                    </div>
</div>
                  <!-- A 3 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'A','3').isHighest),'greenFont':(formatJudgesScore(1,'A','3').isLowest)}">
                      {{(formatJudgesScore(1,'A','3').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'A','3').isHighest),'greenFont':(formatJudgesScore(2,'A','3').isLowest)}">
                      {{(formatJudgesScore(2,'A','3').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'A','3').isHighest),'greenFont':(formatJudgesScore(3,'A','3').isLowest)}">
                      {{(formatJudgesScore(3,'A','3').finalScore) || '-'}}
                    </div>
</div>
                  <!-- A 4 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'A','4').isHighest),'greenFont':(formatJudgesScore(1,'A','4').isLowest)}">
                      {{(formatJudgesScore(1,'A','4').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'A','4').isHighest),'greenFont':(formatJudgesScore(2,'A','4').isLowest)}">
                      {{(formatJudgesScore(2,'A','4').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'A','4').isHighest),'greenFont':(formatJudgesScore(3,'A','4').isLowest)}">
                      {{(formatJudgesScore(3,'A','4').finalScore) || '-'}}
                    </div>
</div>
                  <!-- A 5 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'A','5').isHighest),'greenFont':(formatJudgesScore(1,'A','5').isLowest)}">
                      {{(formatJudgesScore(1,'A','5').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'A','5').isHighest),'greenFont':(formatJudgesScore(2,'A','5').isLowest)}">
                      {{(formatJudgesScore(2,'A','5').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'A','5').isHighest),'greenFont':(formatJudgesScore(3,'A','5').isLowest)}">
                      {{(formatJudgesScore(3,'A','5').finalScore) || '-'}}
                    </div>
</div>
                  <!-- A 6 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(1,'A','6').isHighest),'greenFont':(formatJudgesScore(1,'A','6').isLowest)}">
                      {{(formatJudgesScore(1,'A','6').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(2,'A','6').isHighest),'greenFont':(formatJudgesScore(2,'A','6').isLowest)}">
                      {{(formatJudgesScore(2,'A','6').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(3,'A','6').isHighest),'greenFont':(formatJudgesScore(3,'A','6').isLowest)}">
                      {{(formatJudgesScore(3,'A','6').finalScore) || '-'}}
                    </div>
</div>
                  <!-- A 7 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore doubleRow " :class="{'redFont':(formatJudgesScore(1,'A','7').isHighest),'greenFont':(formatJudgesScore(1,'A','7').isLowest)}">
                      {{(formatJudgesScore(1,'A','7').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore doubleRow " :class="{'redFont':(formatJudgesScore(2,'A','7').isHighest),'greenFont':(formatJudgesScore(2,'A','7').isLowest)}">
                      {{(formatJudgesScore(2,'A','7').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore doubleRow " :class="{'redFont':(formatJudgesScore(3,'A','7').isHighest),'greenFont':(formatJudgesScore(3,'A','7').isLowest)}">
                      {{(formatJudgesScore(3,'A','7').finalScore) || '-'}}
                    </div>
</div>
                </div>
                <!-- 得分 -->
                <div class="technology-shootingGuard">
                  <!-- A 1 -->
                  <div class="singleRow">
                    {{calculateScore('A','1')}}
                  </div>
                  <!-- A 2 -->
                  <div class="singleRow">
                    {{calculateScore('A','2')}}
                  </div>
                  <!-- A 3 -->
                  <div class="singleRow">
                    {{calculateScore('A','3')}}
                  </div>
                  <!-- A 4 -->
                  <div class="singleRow">
                    {{calculateScore('A','4')}}
                  </div>
                  <!-- A 5 -->
                  <div class="singleRow">
                    {{calculateScore('A','5')}}
                  </div>
                  <!-- A 6 -->
                  <div class="doubleRow">
                    {{calculateScore('A','6')}}
                  </div>
                  <!-- A 7 -->
                  <div class="doubleRow">
                    {{calculateScore('A','7')}}
                  </div>
                </div>
                <!-- 类目得分总分 -->
                <div class="technology-totalScore">
                  {{(scoreDetail.classA || 0).toFixed(1)}}
                </div>

              </div>
              <!-- 模范编辑代码，规范使用 -->
              <div class="specification">
                <!-- 类目 -->
                <div class="specification-cidr">
                  能够高效、合理地实用 AI 完成项目 (0-40分)
                </div>
                <!-- 得分点 -->
                <div class="specification-scorePoints">
                  <div class="singleRow">
                    1、项目有设置明确、友好的的社会责任和愿景 (4分)
                  </div>
                  <div class="singleRow">
                    2、产品功能点清晰，用途明确和产品推广意义 (4分)
                  </div>
                  <div class="singleRow">
                    3、汇报过程中能体出现团队合作，分工明确 (4分)
                  </div>
                  <div class="singleRow">
                    4、汇报资料 (页面)使用 AI 生成，集成到 NeuCharBox 呈现，内容合理、美观 (4分)
                  </div>
                  <div class="singleRow">
                    5、具有可重复验证的测试过程和测试数据 (4分)
                  </div>
                  <div class="doubleRow">
                    6、合理规划并使用了 NeuCharBox AI 的页面自动生成能力、任务生成能力、动态数据分析能力各 4 分 (可多选，满分12分)
                  </div>
                  <div class="lastRow2">
                    7、合理使用外部工具 (AI 或其他)：有 1 个 4分、有 1 个以上 8分 (满分8分)
                  </div>
                </div>
                <!-- 评委打分 -->
                <div class="specification-judgesGiveScore">
                  <!-- B 1 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'B','1').isHighest),'greenFont':(formatJudgesScore(1,'B','1').isLowest)}">
                      {{(formatJudgesScore(1,'B','1').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'B','1').isHighest),'greenFont':(formatJudgesScore(2,'B','1').isLowest)}">
                      {{(formatJudgesScore(2,'B','1').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'B','1').isHighest),'greenFont':(formatJudgesScore(3,'B','1').isLowest)}">
                      {{(formatJudgesScore(3,'B','1').finalScore) || '-'}}
                    </div>
</div>
                  <!-- B 2 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'B','2').isHighest),'greenFont':(formatJudgesScore(1,'B','2').isLowest)}">
                      {{(formatJudgesScore(1,'B','2').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'B','2').isHighest),'greenFont':(formatJudgesScore(2,'B','2').isLowest)}">
                      {{(formatJudgesScore(2,'B','2').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'B','2').isHighest),'greenFont':(formatJudgesScore(3,'B','2').isLowest)}">
                      {{(formatJudgesScore(3,'B','2').finalScore) || '-'}}
                    </div>
</div>
                  <!-- B 3 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'B','3').isHighest),'greenFont':(formatJudgesScore(1,'B','3').isLowest)}">
                      {{(formatJudgesScore(1,'B','3').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'B','3').isHighest),'greenFont':(formatJudgesScore(2,'B','3').isLowest)}">
                      {{(formatJudgesScore(2,'B','3').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'B','3').isHighest),'greenFont':(formatJudgesScore(3,'B','3').isLowest)}">
                      {{(formatJudgesScore(3,'B','3').finalScore) || '-'}}
                    </div>
</div>
                  <!-- B 4 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'B','4').isHighest),'greenFont':(formatJudgesScore(1,'B','4').isLowest)}">
                      {{(formatJudgesScore(1,'B','4').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'B','4').isHighest),'greenFont':(formatJudgesScore(2,'B','4').isLowest)}">
                      {{(formatJudgesScore(2,'B','4').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'B','4').isHighest),'greenFont':(formatJudgesScore(3,'B','4').isLowest)}">
                      {{(formatJudgesScore(3,'B','4').finalScore) || '-'}}
                    </div>
</div>
                  <!-- B 5 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'B','5').isHighest),'greenFont':(formatJudgesScore(1,'B','5').isLowest)}">
                      {{(formatJudgesScore(1,'B','5').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'B','5').isHighest),'greenFont':(formatJudgesScore(2,'B','5').isLowest)}">
                      {{(formatJudgesScore(2,'B','5').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'B','5').isHighest),'greenFont':(formatJudgesScore(3,'B','5').isLowest)}">
                      {{(formatJudgesScore(3,'B','5').finalScore) || '-'}}
                    </div>
</div>
                  <!-- B 6 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(1,'B','6').isHighest),'greenFont':(formatJudgesScore(1,'B','6').isLowest)}">
                      {{(formatJudgesScore(1,'B','6').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(2,'B','6').isHighest),'greenFont':(formatJudgesScore(2,'B','6').isLowest)}">
                      {{(formatJudgesScore(2,'B','6').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(3,'B','6').isHighest),'greenFont':(formatJudgesScore(3,'B','6').isLowest)}">
                      {{(formatJudgesScore(3,'B','6').finalScore) || '-'}}
                    </div>
</div>
                  <!-- B 7 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore lastRow2" :class="{'redFont':(formatJudgesScore(1,'B','7').isHighest),'greenFont':(formatJudgesScore(1,'B','7').isLowest)}">
                      {{(formatJudgesScore(1,'B','7').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore lastRow2" :class="{'redFont':(formatJudgesScore(2,'B','7').isHighest),'greenFont':(formatJudgesScore(2,'B','7').isLowest)}">
                      {{(formatJudgesScore(2,'B','7').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore lastRow2" :class="{'redFont':(formatJudgesScore(3,'B','7').isHighest),'greenFont':(formatJudgesScore(3,'B','7').isLowest)}">
                      {{(formatJudgesScore(3,'B','7').finalScore) || '-'}}
                    </div>
</div>
                </div>
                <div class="specification-shootingGuard">
                  <!-- B 1 -->
                  <div class="singleRow">
                    {{calculateScore('B','1')}}
                  </div>
                  <!-- B 2 -->
                  <div class="singleRow">
                    {{calculateScore('B','2')}}
                  </div>
                  <!-- B 3 -->
                  <div class="singleRow">
                    {{calculateScore('B','3')}}
                  </div>
                  <!-- B 4 -->
                  <div class="singleRow">
                    {{calculateScore('B','4')}}
                  </div>
                  <!-- B 5 -->
                  <div class="singleRow">
                    {{calculateScore('B','5')}}
                  </div>
                  <!-- B 6 -->
                  <div class="doubleRow">
                    {{calculateScore('B','6')}}
                  </div>
                  <!-- B 7 -->
                  <div class="lastRow2">
                    {{calculateScore('B','7')}}
                  </div>
                </div>
                <div class="specification-totalScore">
                  {{(scoreDetail.classB || 0).toFixed(1)}}
                </div>
              </div>
              <!-- 开发速度 developmentSpe-->
              <div class="developmentSpe">
                <!-- 类目 -->
                <div class="developmentSpe-cidr">
                  创新程度 (0-48分)
                </div>
                <!-- 得分点 -->
                <div class="developmentSpe-scorePoints">
                  <div class="doubleRow ">
                    1、有至少 2 个让人眼前一亮的创新点 4分、有至少 3 个 8分 (满分8分)
                  </div>
                  <div class="doubleRow">
                    2、此项目解决的问题，使用当前主流方式具有比较大的难度 2分；使用当前主流方式过于依赖人力 2分 (满分4分)
                  </div>
                  <div class="singleRow">
                    3、产品能够和人类友好互动 (肢体或语音) 4分
                  </div>
                  <div class="doubleRow">
                    4、产品用户体验和整体创新性：4、8、12、16、20、24、28、32分 (各组不重复打同一分) (满分32分)
                  </div>
                </div>
                <!-- 评委打分 -->
                <div class="developmentSpe-judgesGiveScore">
                  <!-- C 1 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(1,'C','1').isHighest),'greenFont':(formatJudgesScore(1,'C','1').isLowest)}">
                      {{(formatJudgesScore(1,'C','1').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(2,'C','1').isHighest),'greenFont':(formatJudgesScore(2,'C','1').isLowest)}">
                      {{(formatJudgesScore(2,'C','1').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(3,'C','1').isHighest),'greenFont':(formatJudgesScore(3,'C','1').isLowest)}">
                      {{(formatJudgesScore(3,'C','1').finalScore) || '-'}}
                    </div>
</div>
                  <!-- C 2 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(1,'C','2').isHighest),'greenFont':(formatJudgesScore(1,'C','2').isLowest)}">
                      {{(formatJudgesScore(1,'C','2').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(2,'C','2').isHighest),'greenFont':(formatJudgesScore(2,'C','2').isLowest)}">
                      {{(formatJudgesScore(2,'C','2').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(3,'C','2').isHighest),'greenFont':(formatJudgesScore(3,'C','2').isLowest)}">
                      {{(formatJudgesScore(3,'C','2').finalScore) || '-'}}
                    </div>
</div>
                  <!-- C 3 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(1,'C','3').isHighest),'greenFont':(formatJudgesScore(1,'C','3').isLowest)}">
                      {{(formatJudgesScore(1,'C','3').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(2,'C','3').isHighest),'greenFont':(formatJudgesScore(2,'C','3').isLowest)}">
                      {{(formatJudgesScore(2,'C','3').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore singleRow" :class="{'redFont':(formatJudgesScore(3,'C','3').isHighest),'greenFont':(formatJudgesScore(3,'C','3').isLowest)}">
                      {{(formatJudgesScore(3,'C','3').finalScore) || '-'}}
                    </div>
</div>
                  <!-- C 4 -->
                  <div class="judgesGiveScore-line">
                    <!-- 评委1 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(1,'C','4').isHighest),'greenFont':(formatJudgesScore(1,'C','4').isLowest)}">
                      {{(formatJudgesScore(1,'C','4').finalScore) || '-'}}
                    </div>
                    <!-- 评委2 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(2,'C','4').isHighest),'greenFont':(formatJudgesScore(2,'C','4').isLowest)}">
                      {{(formatJudgesScore(2,'C','4').finalScore) || '-'}}
                    </div>
                    <!-- 评委3 -->
                    <div class="item-judgesGiveScore doubleRow" :class="{'redFont':(formatJudgesScore(3,'C','4').isHighest),'greenFont':(formatJudgesScore(3,'C','4').isLowest)}">
                      {{(formatJudgesScore(3,'C','4').finalScore) || '-'}}
                    </div>
</div>
                </div>
                <div class="developmentSpe-shootingGuard">
                  <!-- c 1 -->
                  <div class="doubleRow">
                    {{calculateScore('C','1')}}
                  </div>
                  <!-- c 2 -->
                  <div class="doubleRow">
                    {{calculateScore('C','2')}}
                  </div>
                  <!-- c 3 -->
                  <div class="singleRow">
                    {{calculateScore('C','3')}}
                  </div>
                  <!-- c 4 -->
                  <div class="doubleRow">
                    {{calculateScore('C','4')}}
                  </div>
                </div>
                <div class="developmentSpe-totalScore">
                  {{(scoreDetail.classC || 0).toFixed(1)}}
                </div>
              </div>
              <!-- 右侧总分 -->
              <div class="totalScoreBox">
                {{totalScore}}
              </div>
            </div>
            <!-- 关闭按钮 -->
            <div class="closeBtn" @click="isScoreDetailShow = false"></div>
          </div>
        </div>
        <!-- 评分详情弹框 -->
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '@/utils/drawMixin'
import { formatTime } from '@/utils/index.js'
//
export default {
  mixins: [drawMixin],
  data() {
    return {
      loading: false,
      // 获取当前时间计时器
      timing: null,
      timing3: null,

      // 当前日期
      currentDate: '',
      // 倒计时
      countDown: '',

      // 队伍列表
      teamList: [],
      // 队伍详情
      teamDetail: '',
      // 是否展示队员详情
      isDetailShow: false,
      // 评委评分列表
      scoreList: [],
      // 评分详情
      scoreDetail: '',
      // 评委评分详情
      isScoreDetailShow: false,
      // 投票列表
      voteList: []
    }
  },
  components: {},
  computed: {
    // 计算总分
    totalScore() {
      let score = 0
      if (this.scoreDetail.classA) {
        score += this.scoreDetail.classA
      }
      if (this.scoreDetail.classB) {
        score += this.scoreDetail.classB
      }
      if (this.scoreDetail.classC) {
        score += this.scoreDetail.classC
      }
      return score.toFixed(1)
    },
    // 队伍列表
    teamListResult() {
      let _reultList = [...this.teamList]
      // 分数
      if (this.scoreList && this.scoreList.length > 0) {
        this.scoreList.forEach((element) => {
          if (
            this.scoreDetail &&
            element.teamIndex === this.scoreDetail.teamIndex
          ) {
            this.scoreDetail = element
          }
          _reultList.forEach((item) => {
            item.judgesScore = item.judgesScore
              ? item.judgesScore
              : '0.0+0.0+0.0=0.0'
            if (!item.totalScore) {
              let totalScore = 0
              item.matchDataCheckPoints.forEach((item2) => {
                totalScore += item2.score
              })
              item.totalScore = totalScore.toFixed(1)
            }
            if (Number(item.teamNumber) === Number(element.teamIndex)) {
              let classA = element.classA || 0
              let classB = element.classB || 0
              let classC = element.classC || 0
              let totalClass = Number(classA) + Number(classB) + Number(classC)
              item.judgesScore = `${classA.toFixed(1)}+${classB.toFixed(
                1
              )}+${classC.toFixed(1)}=${totalClass.toFixed(1)}`
              let totalScore = totalClass
              // 总分
              item.matchDataCheckPoints.forEach((item2) => {
                totalScore += item2.score
              })
              item.totalScore = totalScore.toFixed(1)
            }
          })
        })
      }
      // 投票数量
      if (this.voteList && this.voteList.length) {
        this.voteList.forEach((element) => {
          _reultList.forEach((item) => {
            if (Number(item.teamNumber) === Number(element.teamIndex)) {
              item.vote = element.voteNumber
            }
          })
        })
      }
      return _reultList
    }
  },
  filters: {},
  created() {
    // window.screen.orientation.lock('landscape-primary')
  },
  async mounted() {
    // 获取当前时间
    this.timeFn()
    // 获取倒计时
    await this.getCountDown()
    // 获取队伍列表
    await this.getList()
    // 获取评委评分
    await this.getJudgesScore()
    // 获取投票数据
    await this.getNumberVotes()
    // 数据每 10 秒刷新一次 (含 Last 倒计时)
    this.timing3 = setInterval(() => {
      this.getList()
      this.getJudgesScore()
      this.getNumberVotes()
      this.getCountDown()
    }, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timing)
    clearInterval(this.timing3)
  },
  methods: {
    formatTeamName(item) {
      if (!item) return ''
      const name = (item.teamName || '').trim()
      if (name && !/^Group\s+\d+$/i.test(name)) {
        return name
      }
      return `Group ${item.teamNumber}`
    },
    hasTeamIntro(item) {
      if (!item) return false
      return !!(item.teamDescription || item.teamCaptain)
    },
    // 获取倒计时
    async getCountDown() {
      await this.$axios
        .get('/api/Opathon/GetSurplusDuration/Opathon_GetSurplusDuration')
        .then((response) => {
          // console.log('获取倒计时', response.data.data)
          let countDown = '0h0m0s'
          if (response.data.data) {
            countDown = this.dayTosecondToHour(response.data.data)
          }
          this.countDown = countDown
        })
    },
    // 获取队伍列表
    async getList() {
      await this.$axios
        .get('/api/Opathon/GetAllData/Opathon_GetAllData')
        .then((response) => {
          // console.log('获取队伍列表', response.data.data)
          this.teamList = response.data.data || []
        })
        .catch(() => {
          this.$message.error('获取队伍列表数据失败')
        })
    },
    // 获取评委评分
    async getJudgesScore() {
      await this.$axios
        .post(
          '/api/Opathon.Xncf.Judges/JudgeScoreAppService/Xncf.Judges_JudgeScoreAppService.GetAsync'
        )
        .then((response) => {
          // console.log('获取评委评分', response.data.data)
          this.scoreList = response.data.data || []
          // 队伍列表 评委技术分、总分
        })
        .catch(() => {
          // this.$message.error('获取评委评分数据失败')
        })
    },
    // 获取投票数量
    async getNumberVotes() {
      await this.$axios
        .get('/api/Opathon/GetVotes/Opathon_GetVotes')
        .then((response) => {
          // console.log('获取投票数量', response.data.data)
          this.voteList = response.data.data || []
        })
        .catch(() => {
          this.$message.error('获取投票数据失败')
        })
    },
    // 查看详情
    seeDetails(item) {
      // console.log('查看详情',item)
      this.teamDetail = item
      this.isDetailShow = true
    },
    // 查看评分详情
    seeScoreDetails(item) {
      const teamNumber = item.teamNumber
      const result = this.scoreList.find(
        (item) => Number(item.teamIndex) === Number(teamNumber)
      )
      // console.log('查看评分详情',result)
      // if (!result) return
      this.scoreDetail = result || { rules: [] }
      this.isScoreDetailShow = true
    },
    // 按评委槽位（1–3）获取评分明细
    formatJudgesScore(judgeSlot, className, subName) {
      const JudgeResult = this.scoreDetail.rules.find(
        (item) =>
          item.rule.topClassName === className &&
          item.rule.subClassName === subName
      )
      let socre = {}
      if (JudgeResult) {
        let socreResult = JudgeResult.scores.find(
          (item) => Number(item.judgeSlot) === Number(judgeSlot)
        )
        // console.log('socreResult', socreResult)
        if (socreResult) {
          socre = {
            ...socreResult,
            finalScore:
              socreResult.finalScore === 0 ? '0' : socreResult.finalScore
          }
        }
      }
      return socre
    },
    // 获取分类得分
    calculateScore(className, subName) {
      // console.log('计算得分', className, subName)
      const JudgeResult = this.scoreDetail.rules.find(
        (item) =>
          item.rule.topClassName === className &&
          item.rule.subClassName === subName
      )
      let socre = 0
      if (JudgeResult) {
        socre = JudgeResult.rule.totalAvgScore || 0
      }
      return socre > 0 ? socre.toFixed(1) : 0
    },
    // 跳转转直播
    goLive() {
      window.open('https://live.csdn.net/room/MicrosoftReactor/SQMS3t8n/')
    },
    // 获取当前时间
    timeFn() {
      this.timing = setInterval(() => {
        const dateDay = formatTime(new Date(), 'HH:mm:ss')
        const dateYear = formatTime(new Date(), 'yyyy.MM.dd')
        this.currentDate = `${dateYear} ${dateDay}`
      }, 1000)
    },
    // 剩余时间处理
    dayTosecondToHour(msd) {
      // parseInt 解析一个字符串，并返回一个整数。
      var time = msd
      var second = parseInt(time) // 秒
      var minute = 0 // 分
      var hour = 0 // 小时
      var day = 0 // 天
      if (second > 60) {
        minute = parseInt(second / 60) || 0
        second = parseInt(second % 60) || 0
        if (minute > 60) {
          hour = parseInt(minute / 60) || 0
          minute = parseInt(minute % 60) || 0
          if (hour > 24) {
            day = parseInt(hour / 24) || 0
            hour = parseInt(hour % 24) || 0
          }
        }
      }
      var result = '' + parseInt(second) + 's'
      if (minute > 0) {
        result = '' + parseInt(minute) + 'm' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + 'h' + result
      }
      if (day > 0) {
        result = '' + parseInt(day) + 'd' + result
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/index.scss';
</style>
